import Header from "./components/Header/Header.jsx";
import Home from "./pages/Home/Home.jsx";
import TestimonialsPage from "./pages/Testimonials-Page/Testmonials-Page.jsx";
import Work from "./components/Work/Work.jsx";
import WorkPage from "./pages/Work/Work-Page.jsx";
import AboutPage from "./pages/About-Page/About-Page.jsx";
import ContactPage from "./pages/Contact-Page/Contact-Page.jsx";
import Footer from "./components/Footer/Footer.jsx";
import { Route, Routes, useLocation, useParams } from "react-router-dom";
import "./App.css";

function App() {
  const { pathname } = useLocation();
  const segments = pathname.split("/");
  const location = segments[segments.length - 1];
  return (
    <div className="App">
      <Header location={location} />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="work/:project" element={<Work />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
